<template>
  <pl-dialog size="confirm_size" title="Follow Up Questions" :disableOutsideClick="true" @close="handleCloseModal">
    <div class="flex flex-col h-full">
      <div class="flex flex-col space-y-6 flex-grow h-full px-6 pt-2 pb-4">
        <div class="text-gray-800 font-poppins">
          You can <b class="font-semibold">edit the questions</b> in discussion tab. This action can be undone.
        </div>
        <div class="flex items-center space-x-2">
          <input
            v-model="isToGoDiscussionTab"
            type="checkbox"
            class="cursor-pointer"
          />
          <div class="text-sm font-poppins text-gray-700">
            <p class="">Go to Discussion Tab</p>
          </div>
        </div>
      </div>
      <div class="flex items-center space-x-2 justify-between px-6 pb-5 pt-2">
        <button  @click="handleCloseModal()" class="w-full px-4 py-2 bg-gray-50 rounded-md hover:bg-gray-100 border border-solid border-gray-200 text-gray-700">Cancel</button>
        <button @click="handleAddQuestions()" class="w-full px-4 py-2 bg-primary flex items-center space-x-2 rounded-md hover:bg-primary-dark border border-solid border-primary text-white">
          <span>Add Follow Up Questions</span>
          <div v-if="isAdding === true" class="loader"></div>
        </button>
      </div>
    </div>
    <!-- <div class="flex flex-col h-full">
      <div class="flex flex-col flex-grow h-96 overflow-y-auto  px-6 py-4">
        <div v-for="(question, index) in new_guiding_questions" :key="index" class="flex h-full space-x-12 w-full items-start justify-between mb-6">
          <div class="flex items-start space-x-2 w-full">
            <div class="font-poppins font-semibold text-gray-800">{{ index + 1 }}.</div>
            <div class="font-poppins font-light text-gray-800">
              <div v-if="question.generatedBy">
                <span>{{ question.question }}</span> <span class="text-pinky text-xs ">Generated By Genie</span>
              </div>
              <div v-else class="flex items-center space-x-2">
                <span>{{ question.question }}</span>
              </div>
            </div>
          </div>
          <div class="flex items-center">
            <div class="flex items-center justify-end space-x-3">
              <toggle-button
                :labels="false"
                :title="'Visible To Students'"
                v-model="question.is_active"
                color="#72ccd7"
                class="toggle-button-class"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="border-t border-gray-200 p-4 flex justify-end items-center ">
        <button class="px-4 py-2 bg-primary hover:bg-primary-dark rounded text-white flex items-center space-x-2">
          <span>Go to Discussion</span>
          <i class="fa-solid fa-arrow-right"></i>
        </button>
      </div>
    </div> -->
  </pl-dialog>
</template>

<script>
  import Vue from 'vue';
  import { mapGetters } from 'vuex';
  import { EventBus } from 'utils/event-bus';

  export default Vue.extend({
    data() {
      return {
        new_guiding_questions: [],
        followQuestions: [],
        allQuestions: [],
        isToGoDiscussionTab: true,
        isAdding: false,
      };
    },
    computed: {
      ...mapGetters(['hasTeacherPermissionsInCourse', 'getCurrentDiscussion']),
    },
    props: {
      followUpQuestions: {
        type: Array,
      }
    },
    methods: {
      handleCloseModal: async function() {
        this.$emit('close');
      },
      handleAddQuestions: async function() {
        try {
          this.isAdding = true;
          await this.$store.dispatch('saveLiveDiscussionSettings', { id: this.getCurrentDiscussion.id, toggleable_guiding_questions: this.new_guiding_questions });
          if (this.isToGoDiscussionTab === true) {
            EventBus.$emit('handleTab', 'discussion');
            this.handleCloseModal();
            this.isAdding = false;
          }
        } catch (error) {
          console.log(error);
        }
      }
    },
    mounted: async function() {
      this.new_guiding_questions = this.getCurrentDiscussion.toggleable_guiding_questions.concat(this.getCurrentDiscussion.genie_recap.questions);
    }
  });
</script>
<style lang="scss" scoped>
  input[type='checkbox'] {
    width: 1.25rem !important;
    height: 1.25rem !important;
    -webkit-appearance: none;
    -moz-appearance: none;
    -o-appearance: none;
    appearance: none;
    box-shadow: none;
    font-size: 0.8rem;
    text-align: center;
    line-height: 1.25rem;
    border-radius: 0.25rem;
    --tw-bg-opacity: 1;
    background-color: rgba(243, 244, 246, var(--tw-bg-opacity));
  }
  input[type='checkbox']:checked {
    background-color: #72ccd7;
  }
  input[type='checkbox']:checked::after {
    font-family: 'Font Awesome 5 Free';
    content: '\f00c';
    font-weight: 900;
    color: white;
    line-height: 1.25rem;
  }
</style>



// WEBPACK FOOTER //
// FollowUpQuestionsTranscription.vue?3370dfba